import React, { useState, useEffect } from "react";
import InputField from "../../components/InputComponent/InputField";
import ButtonWithIcon from "../../components/ButtonwithIcon/ButtonWithIcon";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance from "../../axiosInstance";
import "./PersonalDetails.scss";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaWhatsapp,
} from "react-icons/fa"; // Import icons from react-icons

const SocialMediaLinks = () => {
  const [socialLinks, setSocialLinks] = useState({
    twitterLink: "",
    linkedinLink: "",
    fbLink: "",
    instaLink: "",
    whatsappNo: "",
  });
  const [isInitialSave, setIsInitialSave] = useState(true); // Track if this is the first save

  useEffect(() => {
    fetchSocialMediaLinks();
  }, []);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setSocialLinks((prevLinks) => ({
      ...prevLinks,
      [id]: value,
    }));
  };

  const fetchSocialMediaLinks = async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_EMPLOYEE_URL}/social-media`,
      );
      const data = response.data.data;

      setSocialLinks({
        twitterLink: data.twitterLink || "",
        linkedinLink: data.linkdilenLink || "", // 🔥 map typo
        fbLink: data.fbLink || "",
        instaLink: data.instaLink || "",
        whatsappNo: data.whatssappNo || "", // 🔥 map typo
      });
      setIsInitialSave(false); // Set to false after fetching existing links
    } catch (error) {
      console.error("Error fetching social media links", error);
      toast.error("Failed to fetch social media links!");
    }
  };
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Function to ensure links start with 'https://'
    const formatLink = (link) => {
      if (!link) return ""; // Keep empty values as they are
      return link.startsWith("http://") || link.startsWith("https://")
        ? link
        : `https://${link}`;
    };

    // Update socialLinks with formatted URLs
    const formattedLinks = {
      ...socialLinks,
      twitterLink: formatLink(socialLinks.twitterLink),
      linkdilenLink: formatLink(socialLinks.linkedinLink), // 🔥 typo must match backend
      fbLink: formatLink(socialLinks.fbLink),
      instaLink: formatLink(socialLinks.instaLink),
      whatssappNo: socialLinks.whatsappNo, // 🔥 typo must match backend
    };

    try {
      if (isInitialSave) {
        // First submission (POST)
        await axiosInstance.post(
          `${process.env.REACT_APP_API_EMPLOYEE_URL}/social-media`,
          formattedLinks,
        );
        setIsInitialSave(false);
        toast.success("Social media links saved successfully!");
      } else {
        // Subsequent submissions (PUT)
        await axiosInstance.put(
          `${process.env.REACT_APP_API_EMPLOYEE_URL}/social-media`,
          formattedLinks,
        );
        toast.success("Social media links updated successfully!");
      }
      fetchSocialMediaLinks(); // Refresh links after saving
    } catch (error) {
      console.error("Error submitting social media links", error);
      toast.error("Failed to save social media links!");
    }
  };

  const handleDelete = async () => {
    try {
      await axiosInstance.delete(
        `${process.env.REACT_APP_API_EMPLOYEE_URL}/social-media`,
      );
      toast.success("Social media links deleted successfully!");
      setSocialLinks({
        twitterLink: "",
        linkedinLink: "",
        fbLink: "",
        instaLink: "",
        whatsappNo: "",
      });
      setIsInitialSave(true); // Reset to indicate links are deleted
    } catch (error) {
      console.error("Error deleting social media links", error);
      toast.error("Failed to delete social media links!");
    }
  };

  const renderLink = (link, label, Icon) => {
    if (!link)
      return (
        <p>
          <strong>{label}:</strong> Not provided
        </p>
      );

    // Ensure the link starts with http:// or https://
    const formattedLink =
      link.startsWith("http://") || link.startsWith("https://")
        ? link
        : `https://${link}`;

    return (
      <p>
        <strong>{label}:</strong>{" "}
        <a
          href={formattedLink}
          target="_blank"
          rel="noopener noreferrer"
          className="social-link"
        >
          <Icon />
        </a>
      </p>
    );
  };

  return (
    <div className="profile-form">
      <form onSubmit={handleFormSubmit}>
        <div className="form-section">
          <h2>Social Media Links</h2>
          <p>Connect your social media accounts here.</p>
          <InputField
            label="Facebook Link"
            id="fbLink"
            placeholder="Enter your Facebook profile link"
            value={socialLinks.fbLink}
            onChange={handleInputChange}
          />
          <InputField
            label="Instagram Link"
            id="instaLink"
            placeholder="Enter your Instagram profile link"
            value={socialLinks.instaLink}
            onChange={handleInputChange}
          />
          <InputField
            label="LinkedIn Link"
            id="linkedinLink"
            placeholder="Enter your LinkedIn profile link"
            value={socialLinks.linkedinLink}
            onChange={handleInputChange}
          />
          <InputField
            label="Twitter Link"
            id="twitterLink"
            placeholder="Enter your Twitter profile link"
            value={socialLinks.twitterLink}
            onChange={handleInputChange}
          />
          <InputField
            label="WhatsApp Number"
            id="whatsappNo"
            type="tel" // Changed to 'tel' for number input
            placeholder="Enter your WhatsApp number"
            value={socialLinks.whatsappNo}
            onChange={handleInputChange}
          />
          <ButtonWithIcon
            text="Save"
            className="success"
            icon="mdi:content-save"
            type="submit"
          />
        </div>
      </form>
      <div className="social-links-display">
        <h3>Current Links:</h3>
        {renderLink(socialLinks.fbLink, "Facebook", FaFacebook)}
        {renderLink(socialLinks.instaLink, "Instagram", FaInstagram)}
        {renderLink(socialLinks.linkedinLink, "LinkedIn", FaLinkedin)}
        {renderLink(socialLinks.twitterLink, "Twitter", FaTwitter)}
        <p>
          <strong>WhatsApp:</strong> {socialLinks.whatsappNo || "Not provided"}
        </p>
        <ButtonWithIcon
          text="Delete"
          icon="mdi:delete"
          className="cancel-button"
          type="button"
          onClick={handleDelete}
        />
      </div>
    </div>
  );
};

export default SocialMediaLinks;
